<template>
	<div class="footers">
		<div class="w1228">
			<div class="tool df hal">
				<div>
					<div class="logo" @click="$api.toPage('index')"></div>
					<div class="time">工作时间：{{time}}</div>
					<div class="phone">{{phone}}</div>
				</div>
				<div class="flex"></div>
				<div class="btn" @click="tapBtn(1)">隐私政策</div>
				<div class="btn" @click="tapBtn(2)">用户协议</div>
				<div class="btn" @click="tapBtn(3)">关于中智</div>
				<div class="code df cf hao"><img :src="code" alt="">扫一扫小程序下单</div>
			</div>
			<div class="copyright">粤Icp1980980766778356789</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'footers',
	props: {},
	data () {
		return {
			time: '',
			code: '',
			phone: '',
		}
	},
	mounted(){
		this.$ajax.getFooter({}).then(r=>{
			this.time = r.working_hours
			this.code = r.bottom_code
			this.phone = r.customer_service_mobile
		})
	},
	methods: {
		tapBtn(type){
			if(type==1){ // 隐私政策
				this.$api.toPage('articles',{
					id: 'privacy',
				});
			}else if(type==2){ // 用户协议
				this.$api.toPage('articles',{
					id: 'agreement',
				});
			}else if(type==3){ // 关于中智
				this.$api.toPage('articles',{
					id: 'about',
				});
			}
		},
	},
}
</script>

<style lang="less" scoped>
	.footers{
		background: #000504;
		.tool{
			padding: 48px 20px 64px 20px;
		}
		.logo{
			width: 234px;
			height: 50px;
			background: url(../../assets/img/logo3.png) center center / 100% auto no-repeat;
			cursor: pointer;
		}
		.time{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: rgba(255,255,255,0.68);
			line-height: 15px;
			margin-top: 24px;
		}
		.phone{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: rgba(255,255,255,0.68);
			line-height: 15px;
			margin-top: 16px;
		}
		.btn{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 18px;
			color: rgba(255,255,255,0.92);
			line-height: 21px;
			margin-right: 80px;
		}
		.code{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: rgba(255,255,255,0.92);
			line-height: 15px;
			img{
				background: #fff;
				border: 3px solid #fff;
				width: 104px;
				height: 104px;
				display: block;
				object-fit: cover;
				margin-bottom: 8px;
			}
		}
		.copyright{
			border-top: 1px solid rgba(255,255,255,0.16);
			margin: 0 20px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: rgba(255,255,255,0.38);
			line-height: 15px;
			padding: 14px 0 28px 0;
			text-align: center;
		}
		/*
		<div class="tool df hal">
			<div>
				<div class="logo"></div>
				<div class="time">工作时间：{{time}}</div>
				<div class="phone">{{phone}}</div>
			</div>
			<div class="flex"></div>
			<div class="btn" @click="tapBtn(1)">隐私政策</div>
			<div class="btn" @click="tapBtn(2)">用户协议</div>
			<div class="btn" @click="tapBtn(3)">关于中智</div>
			<div class="code df cf hao">
				<div class="img"><img :src="code" alt=""></div>
				扫一扫小程序下单
			</div>
		</div>
		<div class="copyright df wao hao">粤Icp1980980766778356789</div>
		*/ 
		
	}
</style>



// WEBPACK FOOTER //
// src/components/footers/footers.vue